import {CloseButton} from '@headlessui/react'

import {IconClose} from '@sdox/icons'
import {twMerge} from '@sdox/utils'

import {Button} from '../../'

import type {ReactNode} from 'react'

export interface HeaderProps {
  className?: string
  heading?: ReactNode
  showCloseButton?: boolean
}

export const Header = ({
  className,
  heading,
  showCloseButton,
}: HeaderProps) => (
  <div
    className={
      twMerge(
        'flex items-center justify-between self-stretch',
        'py-spacing-8 pl-spacing-36 pr-spacing-12 md:py-spacing-16 md:pl-spacing-48',
        className,
      )}
  >
    {heading ? <p className={'text-p1'}>{heading}</p> : null}
    {showCloseButton ? (
      <CloseButton
        as={Button}
        variant={'flat'}
        size={'medium'}
        leading={<IconClose />}
      />
    ) : null}
  </div>
)
